import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/auth/AuthContext';
import { ApiError } from '@/api/client';
import { initTheme } from '@/lib/theme';
import { readBasePath } from '@/lib/basePath';
import { installConsoleCapture } from '@/feedback/console-buffer';
import { markSessionStart } from '@/feedback/session';
import { App } from './App';
import './styles.css';

// Feedback widget: capture console errors and stamp the session start before anything renders.
installConsoleCapture();
markSessionStart();

initTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // Never retry auth or permission failures.
      retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* '/admin' behind https://billing.spoonity.com/admin, '/' at the root of a host (lib/basePath.ts). */}
    <BrowserRouter basename={readBasePath() || '/'} future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
);
